import { Link } from "@inertiajs/react"
import { Badge } from "@/components/ui/Badge"
import type { MarketSection } from "../types"

interface Props {
  market: MarketSection
  href: string
  displayCurrency: string | null
  /** "1 USD = ₫25,999" for this market's currency, when converting. */
  rateLine: string | null
}

/** Table header on the all-markets page: the market's name (a link into its
 * own revenue page), its currency, and a note when nothing could be converted. */
export default function MarketHeader({ market, href, displayCurrency, rateLine }: Props) {
  const converting = displayCurrency != null && displayCurrency !== market.currency
  return (
    <div className="flex flex-wrap items-center gap-3 border-b px-4 py-3">
      <Link href={href} className="text-sm font-semibold text-link hover:underline">
        {market.name}
      </Link>
      <Badge variant="outline">{market.currency}</Badge>
      {converting && market.converted && (
        <span className="text-xs text-muted-foreground">
          Shown in {displayCurrency}{rateLine ? ` at ${rateLine}` : ""}, {market.currency} underneath.
        </span>
      )}
      {converting && !market.converted && (
        <span className="text-xs text-muted-foreground">
          No exchange rate for {market.currency} yet, so converted figures are blank. Rates refresh nightly.
        </span>
      )}
    </div>
  )
}
